import Analytics from '@/mixins/Analytics';

function getLocalData(key) {
  if (!window.localStorage) return null;

  const data = window.localStorage.getItem(key);
  return JSON.parse(data);
}

// Byte size of every key currently in localStorage (key names + sizes only, never values).
function getLocalStorageKeySizes() {
  const keyBytes = {};
  if (!window.localStorage) return keyBytes;
  for (let i = 0; i < window.localStorage.length; i += 1) {
    const storageKey = window.localStorage.key(i);
    keyBytes[storageKey] = new Blob([window.localStorage.getItem(storageKey) || '']).size;
  }
  return keyBytes;
}

// Origin's storage quota/usage (IndexedDB + Cache Storage, not localStorage).
// Unsupported in some browsers.
async function getStorageEstimate() {
  if (!navigator.storage?.estimate) return null;
  try {
    return await navigator.storage.estimate();
  } catch {
    return null;
  }
}

async function updateLocalData(key, newData) {
  if (!window.localStorage) return;

  const currentLocalData = getLocalData(key);

  const updatedData = {
    ...currentLocalData,
    ...newData,
  };

  const data = currentLocalData ? updatedData : newData;
  try {
    window.localStorage.setItem(key, JSON.stringify(data));
  } catch (e) {
    Analytics.methods.noticeError(e, {
      context: 'localStorageHandler.updateLocalData',
      key,
      errorName: e?.name,
      writeBytes: new Blob([JSON.stringify(data)]).size,
      keyBytes: getLocalStorageKeySizes(),
      storageEstimate: await getStorageEstimate(),
    });
  }
}

// eslint-disable-next-line consistent-return
function removeLocalData(key) {
  if (!window.localStorage) return null;

  window.localStorage.removeItem(key);
}

export {
  getLocalData,
  getLocalStorageKeySizes,
  getStorageEstimate,
  updateLocalData,
  removeLocalData,
};
